<template>
  <div class="wrapper">

    <Background v-if="!loading"/>

    <Nav v-if="!loading" :fixed="true">
      <template v-slot:logo-box>
        <Logo/>
      </template>
      <template v-slot:options-box>
        <Title :title="getTitle"/>
      </template>
    </Nav>

    <div class="loading" v-if="loading">
      <Loader color="white"/>
    </div>

    <div class="start-layer" v-if="!loading && !start">
      <button @click="start = true">
        <div class="circle">
          <font-awesome-icon icon="play" class="icon"/>
        </div>
      </button>
    </div>
    
    <div :class="{ main: true }" v-if="!loading && start">
      <div class="history">
        <div class="row-box">
          <Row v-for="(row, index) in history" :key="index" :object="row"/>
        </div>
      </div>
      <div class="container">

        <div class="person-box">
          <Person/>
        </div>

        <div class="dialog-box">
          <div class="dialog">
            <div :class="dialogAnimation">
              <div class="question-box">
                <Bot v-for="object in question" :key="object.id" :data="object" :hideSpeaker="hideSpeaker" @nextAnswer="nextAnswer" />
              </div>
              <div class="answer-box">
                <div class="selected-answer" v-for="answer in selectedAnswer" :key="answer.id">
                  <div class="text">{{ answer.text }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="answers">
            <div class="answers-box">
              <Answer v-for="answer in answers" :key="answer.id" :data="answer" :answerAnimation="answerAnimation" :hide="answersHide" :hideSpeaker="hideSpeaker" :forceNext="forceNext" @selected="selectAnswer" @end="onAnswerEnd" @continue="onContinue"/>
              
              <div class="end-box" v-if="showEnd">
                <div class="label-row">
                  End of dialog
                </div>
                <div class="button-row">
                  <button @click="onRestart">
                    <font-awesome-icon icon="sync-alt" class="icon"/>
                    <span>Restart</span>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import alert from '@/lib/alert'
import { mapActions, mapGetters } from 'vuex';
import Background from '@/components/Recording/Background'
import Person from '@/components/Recording/Person'
import Bot from '@/components/Recording/Bot'
import Answer from '@/components/Recording/Answer'
import Row from '@/components/Recording/Row'
import Loader from '@/components/Loader'
//Nav
import Nav from '@/components/Nav/Nav'
import Logo from '@/components/Nav/Logo'
import Title from '@/components/Nav/Title'

export default {
  name: 'Recording',
  data() {
    return {
      loading: true,
      question: [],
      answers: [],
      selectedAnswer: [],
      history: [],
      hideSpeaker: false,
      answerAnimation: false,
      answersHide: false,
      move_dialog: false,
      end: false,
      showEnd: false,
      animation: false,
      menu: false,
      forceNext: null,
      continueButton: false,
      continueButtonHide: false,
      selectedAnswerId: null,
      timeouts: [],
      start: false,
    }
  },
  components: {
    Background,
    Person,
    Bot,
    Answer,
    Row,
    Loader,
    //Nav
    Nav,
    Logo,
    Title
  },
  methods: {
    ...mapActions('recording', ['clear', 'loadData', 'restart', 'shiftPath', 'nextQuestion']),
    ...mapActions('player', ['playerStop']),
    exit() {
      this.playerStop();
      this.$router.push(`/main`);
    },
    loadQuestion() {
      this.question = this.currentBotData;
    },
    loadAnswers() {
      if(this.currentAnswers.length > 0) {
        this.answers = this.currentAnswers;
      } else {
        this.answers = [];
        this.end = true;
        this.showEnd = true;
      }
    },
    nextAnswer() {
      this.timeouts.push(setTimeout(() => {
        this.forceNext = this.getNextInPath;
        setTimeout(() => {
          this.forceNext = null;
        }, 500);
        this.shiftPath();
      }, 500));
    },
    selectAnswer(id) {
      this.selectedAnswerId = id;
      this.animation = true;
      this.answersHide = true;
      this.timeouts.push(setTimeout(() => {
        this.continueButton = true;
      }, 1500))
    },
    onContinue() {
      this.continueButtonHide = true;
      this.timeouts.push(setTimeout(() => {
        this.continueButtonHide = false;
        this.continueButton = false;
      }, 1000))
      this.moveAnswer(this.selectedAnswerId);
      this.hideSpeaker = true;
      this.timeouts.push(setTimeout(() => {
        this.answers = [];
      }, 1100))
      this.timeouts.push(setTimeout(() => {
        this.lockScroll = true;
        this.moveDialog();
      }, 1100))
      let answerData = this.currentAnswers.find(answer => {
        return answer.id == this.selectedAnswerId;
      })
      if(answerData.next != undefined) {
        this.timeouts.push(setTimeout(() => {
          this.nextQuestion({ nextId: answerData.next,  answerId: answerData.id })
        }, 2000))
      } else {
        this.onAnswerEnd();
      }
      this.timeouts.push(setTimeout(() => {
        this.lockScroll = false;
        setTimeout(() => {
          let wrapper = document.querySelector('.wrapper');
          window.scrollTo(0, wrapper.scrollHeight);
        }, 1);
        this.clearForNext()
      }, 2000))
    },
    onAnswerEnd() {
      this.end = true;
    },
    moveAnswer(id) {
      this.answerAnimation = true;
      let answer = this.answers.filter(answer => {
        return answer.id == id;
      })
      this.selectedAnswer = answer;
    },
    moveDialog() {
      this.history.push({ question: this.question[0], answer: this.selectedAnswer[0] });
      this.move_dialog = true;
    },
    clearForNext() {
      this.animation = false;
      this.question = [];
      this.selectedAnswer = [];
      this.hideSpeaker = false;
      this.answerAnimation = false;
      this.answersHide = false;
      this.move_dialog = false;
      this.selectedAnswerId = null;
      if(!this.end) {
        this.timeouts.push(setTimeout(this.loadQuestion, 100))
        this.timeouts.push(setTimeout(this.loadAnswers, 600))
      } else {
        this.showEnd = true;
      }
    },
    onRestart() {
      this.menu = false;
      this.restart();
      this.question = [];
      this.answers = [];
      this.selectedAnswer = [];
      this.history = [];
      this.hideSpeaker = false;
      this.answerAnimation = false;
      this.answersHide = false;
      this.move_dialog = false;
      this.end = false;
      this.showEnd = false;
      this.continueButton = false;
      this.continueButtonHide = false;
      this.selectedAnswerId = null;
      this.forceNext = null;
      this.timeouts.forEach(timeout => {
        clearTimeout(timeout);
      });
      this.timeouts = [];
      this.timeouts.push(setTimeout(this.loadQuestion, 100))
      this.timeouts.push(setTimeout(this.loadAnswers, 600))
    }
  },
  created() {
    this.playerStop();
    this.clear();
    const urlParams = new URLSearchParams(window.location.search);
    const dialogId = urlParams.get('dialog_id');
    const type = urlParams.get('type');
    console.log(type);
    
    this.loadData({dialogId, type}).then(() => {
      this.loading = false;
      this.timeouts.push(setTimeout(this.loadQuestion, 500))
      this.timeouts.push(setTimeout(this.loadAnswers, 1000))
    }).catch(err => {
      alert.showError(err);
      this.$router.push('/');
    })
  },
  computed: {
    ...mapGetters('recording', ['currentBotData', 'currentAnswers', 'getTitle', 'getShortId', 'getNextInPath', 'getExerciseId', 'getDialogOwner', 'getDialogDate', 'getDialogMode']),
    scroll() {
      if(window.innerHeight != document.querySelector('.wrapper').offsetHeight) {
        return true;
      } else {
        return false;
      }
    },
    dialogAnimation() {
      if(this.move_dialog) {
        if(window.innerHeight != document.querySelector('.wrapper').offsetHeight) {
          return {
            'new-dialog': true,
            'move_dialog_scroll': true
          }
        } else {
          return {
            'new-dialog': true,
            'move_dialog_no_scroll': true
          }
        }
      } else {
        return {
          'new-dialog': true
        }
      }
    },
    date() {
      let date = new Date(this.getDialogDate);
      let day = date.getDate();
      if(day < 10) {
        day = '0' + day
      }
      let month = date.getMonth() + 1;
      if(month < 10) {
        month = '0' + month
      }
      let year = date.getFullYear();
      let hour = date.getHours();
      if(hour < 10) {
        hour = '0' + hour
      }
      let minutes = date.getMinutes();
      if(minutes < 10) {
        minutes = '0' + minutes
      }
      return `${day}/${month}/${year} ${hour}:${minutes}`;
    }
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  min-height: 100vh;
  background-color: rgb(62, 64, 70);
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
}

.loading {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.start-layer {
  z-index: 2;
  width: 100%;
  flex: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  button {
    width: 6rem;
    height: 6rem;
    background: none;
    outline: none;
    border: none;
    border-radius: 100%;
    &:hover {
      cursor: pointer;
    }
  }

  .circle {
    width: 6rem;
    height: 6rem;
    border-radius: 100%;
    background-color: rgb(62, 64, 70);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .circle:hover .icon {
    color: #ebc659;
  }

  .icon {
    color: white;
    font-size: 2.5rem;
    margin-left: 0.2rem;
    transition: 0.3s;
  }
}

.main {
  width: 100vw;
  flex: auto;
  z-index: 2;
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 5rem;

  @media (min-width: 1600px) {
    width: 100rem;
  }
}

.history {
  width: 100%;
  min-height: calc(35vh - 5rem);
  height: auto;
  display: grid;
  align-content: flex-end;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: ". row row";
  @media (max-width: 1050px) {
    grid-template-areas: "row row row";
  }
  @media (max-width: 750px) {
    min-height: calc(25vh - 5rem);
  }
}

.row-box {
  grid-area: row;
  padding-bottom: 2rem;
}

.container {
  width: 100%;
  min-height: 65vh;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: 
  ". dialog dialog"
  ". dialog dialog"
  ". dialog dialog";

  @media (max-width: 1050px) {
    grid-template-columns: 1fr;
    grid-template-areas: 
    "dialog"
    "dialog"
    "dialog";
  }

  @media (max-width: 750px) {
    min-height: 75vh;
  }
}

.person-box {
  position: fixed;
  height: 65vh;
  width: 33%;
  z-index: 0;
  bottom: 0;
  left: 0;
  @media (min-width: 1600px) {
    width: 33rem;
    left: calc((100vw - 100rem) / 2 );
  }
  @media (max-width: 1050px) {
    width: 50vw;
    max-height: 50vh;
  }
  @media (max-width: 750px) {
    width: 100vw;
    max-height: 50vh;
  }
}

.dialog-box {
  grid-area: dialog;
  display: flex;
  flex-direction: column;
}

.dialog {
  width: 100%;
  min-height: 8rem;
  display: flex;
}

.new-dialog {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  @media (max-width: 750px) {
    flex-direction: column;
  }
}

.move_dialog_no_scroll {
  animation: moveDialog 0.8s ease-out forwards;
  @keyframes moveDialog {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(calc(-100% - 2rem));
    }
  }
}

.move_dialog_scroll {
  transform: translateY(calc(-100% - 2rem));
}

.question-box {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  @media (max-width: 1050px) {
    align-items: center;
  }
  @media (max-width: 750px) {
    min-height: 6rem;
    height: auto;
    width: 100%;
    flex: unset;
    margin-bottom: 1rem;
  }
}

.answer-box {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 750px) {
    min-height: 4rem;
    height: auto;
    width: 100%;
    flex: unset;
  }
}

.selected-answer {
  width: 90%;
  min-height: 4rem;
  background-color: #edc270;
  border-radius: 0.5rem;
  display: flex;
  margin-bottom: 1rem;
  color: #4f4f4f;
  transition: 0.2s;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  opacity: 0;
  animation: answerAppear 1s forwards;
  @keyframes answerAppear {
    0% {
      opacity: 0;
    }
    99% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .text {
    flex: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 1.2rem;
    word-break: break-word;
  }
}

.answers {
  width: 100%;
  flex: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.answers-box {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  @media (max-width: 750px) {
    width: 100%;
  }
}

.end-box {
  width: 90%;
  height: 8rem;
  background-color: #43b64d;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  transition: 0.2s;
  animation: endAppear 0.8s forwards;
  position: absolute;
  bottom: 4rem;
  @keyframes endAppear {
    0% {
      opacity: 0;
      transform: translateY(2rem);
    }
    100% {
      opacity: 1;
      transform: translateY(0rem);
    }
  }

  .label-row {
    width: 100%;
    height: 40%;
    display: flex;
    justify-content: flex-start;
    padding-left: 1rem;
    align-items: center;
    color: white;
    font-size: 1.2rem;
  }

  .button-row {
    width: 100%;
    height: 60%;
    display: flex;
    justify-content: center;
    align-items: center;

    button {
      width: 20rem;
      height: 2.5rem;
      border: none;
      outline: none;
      border-radius: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
      transition: 0.3s;

      @media (max-width: 400px) {
        width: 90%;
      }

      &:hover {
        background-color: rgb(214, 213, 213);
        cursor: pointer;
      }

      span {
        margin-left: 0.5rem;
        font-size: 1.2rem;
      }
    }
  }
}
</style>